import { Icons, Stack, Typography, tokens } from '@cast/design-system';

type IncludedLabelProps = {
  text: string;
};

export const IncludedLabel = ({ text }: IncludedLabelProps) => (
  <Stack direction="row" gap={4} sx={{ alignItems: 'center' }}>
    <Icons.Info size={16} color={tokens.theme.fg.structural.secondary} />
    <Typography
      variant="P12R"
      sx={{ color: tokens.theme.fg.structural.secondary }}
    >
      {text}
    </Typography>
  </Stack>
);
